import { isRangeValid } from '../validators/rangedvalidator';
import { parseDate } from '../utils/formValue';

export default function initRelativeDateRangeValidator() {

    $.validator.addMethod("relativedaterange",
        function (value, element, params) {
            return checkValidity(value, element, params)
        })

    $.validator.unobtrusive.adapters.add("relativedaterange", ["min", "max", "dateformat"],
        function (options) {
            options.rules['relativedaterange'] =
            {
                min: options.params.min,
                max: options.params.max,
                type: "System.DateOnly",
                dateformat: options.params.dateformat
            };
            options.messages['relativedaterange'] = options.message;
        }
    );

    $.validator.addMethod("relativedaterangemin",
        function (value, element, params) {
            return checkValidity(value, element, params)
        })

    $.validator.unobtrusive.adapters.add("relativedaterangemin", ["min", "dateformat"],
        function (options) {
            options.rules['relativedaterangemin'] =
            {
                min: options.params.min,
                type: "System.DateOnly",
                dateformat: options.params.dateformat
            };
            options.messages['relativedaterangemin'] = options.message;
        }
    );

    $.validator.addMethod("relativedaterangemax",
        function (value, element, params) {
            return checkValidity(value, element, params)
        })

    $.validator.unobtrusive.adapters.add("relativedaterangemax", ["max", "dateformat"],
        function (options) {
            options.rules['relativedaterangemax'] =
            {
                max: options.params.max,
                type: "System.DateOnly",
                dateformat: options.params.dateformat
            };
            options.messages['relativedaterangemax'] = options.message;
        }
    );
}

function checkValidity(value, element, params) {
    if (parseDate(value) == null) { return true; } //Continue if not parsed correctly. let date.js handle this

    return isRangeValid(value, element, params)
}